import { A, useNavigate } from "@solidjs/router";
import { PrivateKeyAccount } from "applesauce-accounts/accounts";
import { CreateProfile } from "applesauce-actions/actions";
import { MailboxesFactory } from "applesauce-core/factories";
import { createSignal } from "solid-js";

import { NextIcon, SettingsIcon } from "../components/icons";
import { DEFAULT_LOOKUP_RELAYS, DEFAULT_RELAYS } from "../const";
import { accounts } from "../services/accounts";
import { actions } from "../services/actions";
import { publish } from "../services/pool";

export default function WelcomeView() {
  const navigate = useNavigate();

  const [loading, setLoading] = createSignal(false);
  const createProfile = async () => {
    setLoading(true);
    const { uniqueNamesGenerator, adjectives, colors, animals } = await import(
      "unique-names-generator"
    );

    const account = PrivateKeyAccount.generateNew();
    accounts.addAccount(account);
    accounts.setActive(account);

    // create default outboxes for user
    const mailboxes = await MailboxesFactory.create({
      outboxes: [...DEFAULT_RELAYS],
    }).sign(account.signer);
    publish(mailboxes, [...DEFAULT_RELAYS, ...DEFAULT_LOOKUP_RELAYS]);

    // generate random profile
    const randomName = uniqueNamesGenerator({
      dictionaries: [adjectives, colors, animals],
      separator: " ",
      style: "capital",
    });
    await actions
      .exec(CreateProfile, {
        name: randomName,
        picture: `https://robohash.org/${account.pubkey}`,
      })
      .forEach((event) =>
        publish(event, [...DEFAULT_RELAYS, ...DEFAULT_LOOKUP_RELAYS]),
      );

    setLoading(false);
    navigate("/");
  };

  return (
    <>
      <main class="flex flex-grow h-full overflow-auto flex-col items-center justify-center p-4">
        <h1 class="text-4xl font-bold mb-2 text-primary">wifistr</h1>
        <p class="text-lg text-base-content/70 mb-8">
          open wifi maps powered by nostr
        </p>

        <button
          class="btn btn-primary btn-lg"
          onClick={createProfile}
          disabled={loading()}
        >
          {loading() ? "loading..." : "Get Started"}
        </button>

        <A href="/signin" class="link link-primary mt-2 text-sm">
          signin with existing nostr account
        </A>
      </main>

      <footer class="flex justify-between p-2 pb-safe-or-2 flex-shrink-0">
        <A
          href="/settings"
          class="btn btn-ghost btn-square"
          aria-label="settings"
        >
          <SettingsIcon />
        </A>
        <A href="/" class="btn btn-ghost btn-square" aria-label="skip">
          <NextIcon />
        </A>
      </footer>
    </>
  );
}
